import { render, staticRenderFns } from "./SelectPos.vue?vue&type=template&id=c9563bd8&scoped=true&"
import script from "./SelectPos.vue?vue&type=script&lang=js&"
export * from "./SelectPos.vue?vue&type=script&lang=js&"
import style0 from "./SelectPos.vue?vue&type=style&index=0&id=c9563bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9563bd8",
  null
  
)

export default component.exports